<p>{{ label ? label : '' }} works!</p>
